<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <h2 class="card-title">Mi Perfil</h2>
      </div>
      <div class="card-body">
        <div class="container my-profile">
          <div class="row col-sm-12">
            <div class="col-sm-8">
              <div>
                <small>Nombre cliente</small>
                <h3>{{ $store.state.auth.user.nombre }}</h3>
              </div>
              <br />
              <!-- ================= Datos contacto | Teléfono ================== -->
              <div>
                <small>Teléfono de contacto</small>
                <div class="d-flex align-content-center">
                  <div v-if="editar_telefono.mostrar" class="row">
                    <div class="col-sm-12">
                      <label for="telefono" class="mt-2">
                        <small>
                          <b>Editar teléfono de contacto</b> <br />
                          +52 {{ editar_telefono.contacto.valor }}
                        </small>
                      </label>
                      <div class="row col-sm-12">
                        <div class="input-group">
                          <div class="input-group-append">
                            <div class="input-group-prepend"><span class="input-group-text">+52</span></div>
                            <input
                              v-model="editar_telefono.otp.destinatario"
                              type="number"
                              id="telefono col-sm-8"
                              placeholder="Número a 10 dígitos"
                            />
                            <button type="button" class="btn btn-bpb-primary col-sm-4" @click="enviar_otp">
                              Validar
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="custom-control custom-switch">
                          <input v-model="editar_telefono.contacto.principal" type="checkbox" class="custom-control-input" id="editar_telefono.principal" />
                          <label class="custom-control-label mt-2" for="editar_telefono.principal">
                            <small>
                              Forma predeterminada de contacto
                            </small>
                          </label>
                        </div>
                        <a class="add-contact ml-4 mt-2" @click="cancelar_contacto_modal"><small>Cancelar</small></a>
                      </div>
                      <br />
                    </div>
                  </div>

                  <div v-if="!editar_telefono.mostrar">
                    <div v-for="contacto in metodo_contacto_telefono" class="d-flex align-content-center">
                      <p>+52 {{ contacto.valor }}
                        <a class="add-contact" @click="editar_telefono_modal(contacto)">
                          <img src="@/assets/img/edit.png" alt="Editar" width="18px" class="img-edit" />
                        </a>
                        <a class="add-contact" @click="eliminar_telefono(contacto)">
                          <img src="@/assets/img/trash.png" alt="Eliminar" width="18px" class="img-edit" />
                        </a>
                        <small v-if="contacto.principal" class="predetermined">(Predeterminado)</small>
                      </p>
                    </div>
                  </div>
                </div>

                <div v-if="!agregar_telefono.mostrar">
                  <a class="add-contact" @click="agregar_metodo_contacto('agregar_telefono')">+ Agregar teléfono de contacto</a>
                </div>

                <div v-if="agregar_telefono.mostrar" class="row">
                  <div class="col-sm-12">
                    <label for="telefono" class="mt-2">
                      <small><b>Agregar teléfono de contacto</b></small>
                    </label>
                    <div class="row col-sm-12">
                      <div class="input-group">
                        <div class="input-group-append">
                          <div class="input-group-prepend"><span class="input-group-text">+52</span></div>
                          <input
                            v-model="agregar_telefono.otp.destinatario"
                            type="number"
                            id="telefono col-sm-8"
                            placeholder="Número a 10 dígitos"
                          />
                          <button type="button" class="btn btn-bpb-primary col-sm-4" @click="enviar_otp">
                            Enviar OTP
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="custom-control custom-switch">
                        <input v-model="agregar_telefono.contacto.principal" type="checkbox" class="custom-control-input" id="agregar_telefono.principal" />
                        <label class="custom-control-label mt-2" for="agregar_telefono.principal">
                          <small>
                            Forma predeterminada de contacto
                          </small>
                        </label>
                      </div>
                      <a class="add-contact ml-4 mt-2" @click="cancelar_contacto_modal"><small>Cancelar</small></a>
                    </div>
                  </div>
                </div>
              </div>
              <br />

              <!-- ================= Datos contacto | correo electrónico ================== -->
              <div>
                <small>Correo electrónico</small>
                <div v-if="editar_email.mostrar" class="row">
                  <div class="col-sm-12">
                    <label for="correo-electronico" class="mt-2">
                      <small>
                        <b>Editar correo electronico</b> <br />
                        {{ editar_email.contacto.valor }}
                      </small>
                    </label>
                    <div class="row col-sm-12">
                      <div class="input-group">
                        <div class="input-group-append">
                          <input v-model="editar_email.otp.destinatario" type="email" id="correo-electronico col-sm-8" />
                          <button type="button" class="btn btn-bpb-primary col-sm-4" @click="enviar_otp">
                            Enviar OTP
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="custom-control custom-switch">
                        <input v-model="editar_email.contacto.principal" type="checkbox" class="custom-control-input" id="editar_email.principal" />
                        <label class="custom-control-label mt-2" for="editar_email.principal">
                          <small>
                            Forma predeterminada de contacto
                          </small>
                        </label>
                      </div>
                      <div class="custom-control custom-switch mb-2">
                        <input v-model="editar_email.contacto.facturas" type="checkbox" class="custom-control-input" id="editar_email.facturas" />
                        <label class="custom-control-label mt-2" for="editar_email.facturas">
                          <small>
                            Deseo que me envien a este correo mis facturas <span class="predetermined">(predeterminado)</span>
                          </small>
                        </label>
                      </div>
                    </div>
                    <div class="mb-3">
                      <a class="add-contact mt-4" @click="cancelar_contacto_modal"><small>Cancelar</small></a>
                    </div>
                    <br />
                  </div>
                </div>

                <div v-if="!editar_email.mostrar">
                  <div v-for="contacto in metodo_contacto_email" class="d-flex align-content-center">
                    <p>{{ contacto.valor }}
                      <a class="add-contact" @click.prevent="editar_email_modal(contacto)">
                        <img src="@/assets/img/edit.png" alt="Editar" width="18px" class="img-edit" />
                      </a>
                      <a class="add-contact" @click.prevent="eliminar_email_modal(contacto)">
                        <img src="@/assets/img/trash.png" alt="Editar" width="18px" class="img-edit" />
                      </a>
                      <small v-if="contacto.principal" class="predetermined">(Predeterminado)</small>
                    </p>
                  </div>
                </div>

                <div v-if="!agregar_email.mostrar" class="form-group">
                  <a class="add-contact" @click="agregar_metodo_contacto('agregar_email')">+ Agregar correo electrónico</a>
                </div>
                <div v-if="agregar_email.mostrar" class="row">
                  <div class="col-sm-12">
                    <label for="correo-electronico">
                      <small><b>Agregar correo electrónico</b></small>
                    </label>
                    <div class="row col-sm-12">
                      <div class="input-group">
                        <div class="input-group-append">
                          <input v-model="agregar_email.otp.destinatario" type="email" id="correo-electronico col-sm-8" />
                          <button type="button" class="btn btn-bpb-primary col-sm-4" @click="enviar_otp">
                            Enviar OTP
                          </button>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="custom-control custom-switch">
                        <input v-model="agregar_email.contacto.principal" type="checkbox" class="custom-control-input" id="agregar_email.principal" />
                        <label class="custom-control-label mt-2" for="agregar_email.principal">
                          <small>
                            Forma predeterminada de contacto
                          </small>
                        </label>
                      </div>
                      <div class="custom-control custom-switch mb-2">
                        <input v-model="agregar_email.contacto.facturas" type="checkbox" class="custom-control-input" id="agregar_email.facturas" />
                        <label class="custom-control-label mt-2" for="agregar_email.facturas">
                          <small>
                            Deseo que me envien a este correo mis facturas <span class="predetermined">(predeterminado)</span>
                          </small>
                        </label>
                      </div>
                    </div>
                    <div class="mb-3">
                      <a class="add-contact mt-4" @click="cancelar_contacto_modal"><small>Cancelar</small></a>
                    </div>
                  </div>
                </div>
              </div>
              <br />

              <!-- ================= Datos contacto | Domicilio ================== -->
              <div>
                <small>Domicilio</small>
                <div v-if="editar_domicilio" class="row">
                  <div class="col-sm-12">
                    <label for="correo-electronico" class="mt-2">
                      <small>
                        <b>Editar domicilio</b> <br />
                        <!-- {{ editar_domicilio }} -->
                        Orizaba 31, Col. Roma
                      </small>
                    </label>

                    <div>
                      <form>
                        <div class="form-row">
                          <div class="form-group col-md-12">
                            <label for="inputCalle"><small>Calle</small></label>
                            <input v-model="crear_direccion.calle" type="text" class="form-control" id="inputCalle" />
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-2">
                            <label for="inputNoExt"><small>No. Interior</small></label>
                            <input v-model="crear_direccion.no_interior" type="number" class="form-control" id="inputNoExt" />
                          </div>
                          <div class="form-group col-md-2">
                            <label for="inputNoInt"><small>No. exterior</small></label>
                            <input v-model="crear_direccion.no_exterior" type="number" class="form-control" id="inputNoInt" />
                          </div>
                          <div class="form-group col-md-8">
                            <label for="inputColonia"><small>Colonia</small></label>
                            <input v-model="crear_direccion.colonia" type="text" class="form-control" id="inputColonia" />
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-5">
                            <label for="inputDelMu"><small>Delegación | Municipio</small></label>
                            <input v-model="crear_direccion.delegacion" type="text" class="form-control" id="inputDelMu" />
                          </div>
                          <div class="form-group col-md-5">
                            <label for="inputEdo"><small>Estado</small></label>
                            <input v-model="crear_direccion.estado" type="text" class="form-control" id="inputEdo" />
                          </div>
                          <div class="form-group col-md-2">
                            <label for="inputCP"><small>Código Postal</small></label>
                            <input v-model="crear_direccion.cp" type="number" class="form-control" id="inputCP" />
                          </div>
                        </div>
                      </form>
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="custom-control custom-switch">
                          <input v-model="crear_direccion.principal" type="checkbox" class="custom-control-input" id="customSwitch1" />
                          <label class="custom-control-label" for="customSwitch1">
                            <small>
                              Domicilio predeterminado
                            </small>
                          </label>
                        </div>
                      </div>
                      <div class="d-flex justify-content-center mt-5">
                        <div class="col-sm-4">
                          <button class="btn btn-bpb-primary btn-block" @click="actualizar_domicilio">Guardar</button>
                        </div>
                        <div class="col-sm-4">
                          <button class="btn btn-bpb-invested btn-block" @click="cancelar_direccion">Cancelar</button>
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>

                <div v-if="!editar_domicilio">
                  <div v-for="direccion in usuario.direcciones" class="d-flex align-content-center">
                    <p>{{ direccion.calle+', '+(direccion.no_interior ? 'No interior: '+direccion.no_interior+', ' : '')+(direccion.no_exterior ? 'No exterior: '+direccion.no_exterior+', ' : '')+' '+direccion.colonia+'...' }}</p>
                    <a class="add-contact" @click="editar_domicilio_modal(direccion)">
                      <img src="@/assets/img/edit.png" alt="Editar" width="18px" class="img-edit" />
                    </a>
                    <a class="add-contact" @click="eliminar_domicilio_modal(direccion)">
                      <img src="@/assets/img/trash.png" alt="Editar" width="18px" class="img-edit" />
                    </a>
                    <small v-if="direccion.principal" class="predetermined"> (Predeterminado)</small>
                  </div>
                </div>

                <div v-if="!agregar_domicilio" class="form-group">
                  <a class="add-contact" @click="agregar_domicilio = true">+ Agregar domicilio</a>
                </div>
                <div v-if="agregar_domicilio" class="row">
                  <div class="col-sm-12">
                    <label for="correo-electronico">
                      <small><b>Agregar domicilio</b></small>
                    </label>
                    <div>
                      <form>
                        <div class="form-row">
                          <div class="form-group col-md-12">
                            <label for="inputCalle"><small>Calle</small></label>
                            <input v-model="crear_direccion.calle" type="text" class="form-control" id="inputCalle" />
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-2">
                            <label for="inputNoExt"><small>No. Interior</small></label>
                            <input v-model="crear_direccion.no_interior" type="number" class="form-control" id="inputNoExt" />
                          </div>
                          <div class="form-group col-md-2">
                            <label for="inputNoInt"><small>No. exterior</small></label>
                            <input v-model="crear_direccion.no_exiterior" type="number" class="form-control" id="inputNoInt" />
                          </div>
                          <div class="form-group col-md-8">
                            <label for="inputColonia"><small>Colonia</small></label>
                            <input v-model="crear_direccion.colonia" type="text" class="form-control" id="inputColonia" />
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-5">
                            <label for="inputDelMu"><small>Delegación | Municipio</small></label>
                            <input v-model="crear_direccion.delegacion" type="text" class="form-control" id="inputDelMu" />
                          </div>
                          <div class="form-group col-md-5">
                            <label for="inputEdo"><small>Estado</small></label>
                            <input v-model="crear_direccion.estado" type="text" class="form-control" id="inputEdo" />
                          </div>
                          <div class="form-group col-md-2">
                            <label for="inputCP"><small>Código Postal</small></label>
                            <input v-model="crear_direccion.cp" type="number" class="form-control" id="inputCP" />
                          </div>
                        </div>
                      </form>
                      <div class="d-flex align-items-center">
                        <div class="custom-control custom-switch">
                          <input v-model="crear_direccion.principal" type="checkbox" class="custom-control-input" id="customSwitch1" />
                          <label class="custom-control-label" for="customSwitch1">
                            <small>
                              Domicilio predeterminado
                            </small>
                          </label>
                        </div>
                      </div>
                      <div class="d-flex justify-content-center mt-5">
                        <div class="col-sm-4">
                          <button class="btn btn-bpb-primary btn-block" @click="crear_domicilio">Guardar</button>
                        </div>
                        <div class="col-sm-4">
                          <button class="btn btn-bpb-invested btn-block" @click="cancelar_direccion">Cancelar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </div>
            <!-- ================= Datos contacto | Avatar ================== -->
            <div class="col-sm-4">
              <div class="d-flex align-items-end justify-content-center">
                <img
                  ref="avatar_img_preview"
                  src="https://static.bienparabien.com/img/icons/user.png"
                  alt="Foto perfil"
                  width="200px"
                  height="200px"
                  class="img-profile"
                />
                <div v-if="!editar_avatar">
                  <a class="add-contact" @click="editar_avatar = true">
                    <img src="@/assets/img/edit.png" alt="Editar" width="25px" class="img-edit" />
                  </a>
                </div>
              </div>
              <br />
              <form v-if="editar_avatar">
                <div class="custom-file">
                  <input
                    ref="avatar_select_file"
                    type="file"
                    class="custom-file-input"
                    id="customFileLangHTML"
                    accept=".jpeg,.png,.jpg"
                    @change="subir_avatar"
                  />
                  <label class="custom-file-label" for="customFileLangHTML" data-browse="buscar">Sube archivo</label>
                </div>
                <div>
                  <a class="add-contact" @click="editar_avatar = false"><small>Cancelar</small></a>
                </div>
              </form>

              <br />
              <router-link :to="{ name: 'cambiar-contrasena' }" class="btn btn-bpb-primary col-sm-12 text-center">
                Cambiar contraseña
              </router-link>

              <hr class="mt-4">
              <!-- <div class="mt-3 text-center">
                <small>
                  Enviar las facturas al correo: <br>
                </small>
                <p>{{ metodo_factura_preferido }}</p>
              </div> -->
            </div>
          </div>
        </div>

        <!-- ================= Modal OTP ================== -->
        <div v-if="mostrar_otp_modal" class="modal modal-active">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Validación OTP</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="mostrar_otp_modal = false">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body text-center">
                <div>
                  <img src="@/assets/img/otp.png" alt="OTP" width="150px" />
                </div>
                <br />
                <p>
                  Ingresa aquí el código enviado a tu celular / correo <br />
                  para validar tu identidad.
                </p>
                <div class="otp">
                  <v-otp-input
                    ref="otpInput"
                    input-classes="otp-input"
                    separator=" "
                    :num-inputs="8"
                    :should-auto-focus="true"
                    :is-input-num="true"
                    @on-complete="handleOnComplete"
                  />
                </div>
                <div>
                  <a href="#" @click.prevent="enviar_otp"><small>Reenvíar OTP</small></a>
                </div>
                <br />
                <div class="d-flex justify-content-center">
                  <button type="button" class="btn btn-bpb-primary col-sm-4" data-dismiss="modal" @click="validar_otp">
                    Aceptar
                  </button>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
        <!-- ================= Termina modal OTP ================== -->
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/account";
import apiClientes from "@/api/clientes";

export default {
  data: () => ({
    agregar_telefono: false,
    agregar_correoelectronico: false,
    agregar_domicilio: false,
    editar_telefono: false,
    editar_correoelectronico: false,
    editar_domicilio: false,
    editar_avatar: false,
    usuario: {
      contactos:[]
    }
    ,editar_telefono: {
      mostrar: false
      ,contacto: null
      ,otp: {
        destinatario: null
        ,codigo: null
      }
    }
    ,agregar_telefono: {
      mostrar: false
      ,contacto: {
        principal: false
      }
      ,otp: {
        destinatario: null
        ,codigo: null
      }
    }
    ,editar_email: {
      mostrar: false
      ,contacto: null
      ,otp: {
        destinatario: null
        ,codigo: null
      }
    }
    ,agregar_email: {
      mostrar: false
      ,contacto: {
        principal: false
        ,facturas: false
      }
      ,otp: {
        destinatario: null
        ,codigo: null
      }
    }
    ,mostrar_otp_modal: false
    ,crear_direccion: {
      calle: null
      ,no_interior: null
      ,no_exterior: null
      ,colonia: null
      ,delegacion: null
      ,estado: null
      ,cp: null
      ,principal: null
    }
    ,metodo_proceso: null
  }),
  mounted: function() {
    this.obtener_usuario();
    this.cargar_avatar();
  }
  ,methods: {
    handleOnComplete(value) {
      if (this.editar_telefono.otp.destinatario)
        this.editar_telefono.otp.codigo = value;
      else if (this.agregar_telefono.otp.destinatario)
        this.agregar_telefono.otp.codigo = value;
      else if (this.editar_email.otp.destinatario)
        this.editar_email.otp.codigo = value;
      else if (this.agregar_email.otp.destinatario)
        this.agregar_email.otp.codigo = value;
      else
        return this.$swal('Error','No se a proporcionado un destinatario','error');
    },
    obtener_usuario: async function() {
      try {
        this.usuario = (await apiClientes.obtener_usuario()).data;
        this.$log.info('usuario',this.usuario);
      }catch(e) {
        this.$log.error('err', e);
        this.$swal('Error','Error al cargar el usuario: '+e.message,'error');
      }
    }
    ,cargar_avatar: async function() {
      try {
        let avatar = (await api.obtener_avatar()).data;

        let img = this.$refs.avatar_img_preview;
        img.src = 'data:'+avatar.type+';base64,'+avatar.data;
      }catch(e) {
        this.$log.info('err',e);
        this.$swal('Error','Error al intentar cargar el avatar: '+e.message,'error');
      }
    }
    ,editar_telefono_modal: function(contacto) {
      this.agregar_metodo_contacto('editar_telefono');
      this.editar_telefono = {
        mostrar: true
        ,contacto: contacto
        ,otp: {
          destinatario: contacto.valor
          ,codigo: null
        }
      }
    }
    ,cancelar_contacto_modal: function() {
      this.editar_telefono = {
        mostrar: false
        ,contacto: null
        ,otp: {
          destinatario: null
          ,codigo: null
        }
      }
      this.agregar_telefono = {
        mostrar: false
        ,contacto: {
          principal: false
        }
        ,otp: {
          destinatario: null
          ,codigo: null
        }
      }
      this.editar_email = {
        mostrar: false
        ,contacto: null
        ,otp: {
          destinatario: null
          ,codigo: null
        }
      }
      this.agregar_email = {
        mostrar: false
        ,contacto: {
          principal: false
          ,facturas: false
        }
        ,otp: {
          destinatario: null
          ,codigo: null
        }
      }
    }
    ,enviar_otp: async function() {
      try {

        let destinatario;
        if (this.editar_telefono.otp.destinatario)
          destinatario = this.editar_telefono.otp.destinatario != this.editar_telefono.contacto.valor ? this.editar_telefono.otp.destinatario : 'na';
        else if (this.agregar_telefono.otp.destinatario)
          destinatario = this.agregar_telefono.otp.destinatario;
        else if (this.editar_email.otp.destinatario)
          destinatario = this.editar_email.otp.destinatario != this.editar_email.contacto.valor ? this.editar_email.otp.destinatario : 'na';
        else if (this.agregar_email.otp.destinatario)
          destinatario = this.agregar_email.otp.destinatario;
        else
          return this.$swal('Error','No se a proporcionado un destinatario','error');

        await api.enviar_otp({destinatario: destinatario});

        this.mostrar_otp_modal = true;
      }catch(e) {
        this.$log.info('err', e);
        this.$swal('Error','Error al enviar la OTP: '+e.message,'error');
      }
    }
    ,validar_otp: async function() {
      try {
        let otp;
        if (this.editar_telefono.otp.destinatario)
          otp = this.editar_telefono.otp;
        else if (this.agregar_telefono.otp.destinatario)
          otp = this.agregar_telefono.otp;
        else if (this.editar_email.otp.destinatario)
          otp = this.editar_email.otp;
        else if (this.agregar_email.otp.destinatario)
          otp = this.agregar_email.otp;
        else
          throw new Error('No se a proporcionado un destinatario');

        if (!otp.codigo)
          throw new Error('No se a definido el código');

        if (otp.codigo.length != 8)
          throw new Error('Código inválido, el código consta de 8 digitos');

        if (!otp.destinatario)
          throw new Error('No se a definido el destinatario');

        this.$log.info('otp', otp);
        let res = (await api.validar_otp(otp)).data;
        this.$log.info('res', res);

        if (!res.success)
          throw new Error(res.message);

        let resContactos, successMsg;

        if (this.editar_telefono.otp.destinatario) {
          resContactos = (await apiClientes.editar_metodo_contacto(this.editar_telefono.contacto.id, {
            valor: this.editar_telefono.otp.destinatario
            ,validado: 1
            ,principal: this.editar_telefono.contacto.principal
          })).data;

          successMsg = 'El método de contacto se actualizó correctamente';
        }else if (this.agregar_telefono.otp.destinatario) {
          resContactos = (await apiClientes.crear_metodo_contacto({
            tipo: 'celular'
            ,valor: this.agregar_telefono.otp.destinatario
            ,validado: 1
            ,principal: this.agregar_telefono.contacto.principal
          })).data;

          successMsg = 'El método de contacto se agrego correctamente';
        }else if (this.editar_email.otp.destinatario) {
          resContactos = (await apiClientes.editar_metodo_contacto(this.editar_email.contacto.id, {
            valor: this.editar_email.otp.destinatario
            ,validado: 1
            ,principal: this.editar_email.contacto.principal
            ,facturas: this.editar_email.contacto.facturas
          })).data;

          successMsg = 'El método de contacto se actualizó correctamente';
        }else if (this.agregar_email.otp.destinatario) {
          resContactos = (await apiClientes.crear_metodo_contacto({
            tipo: 'email'
            ,valor: this.agregar_email.otp.destinatario
            ,validado: 1
            ,principal: this.agregar_email.contacto.principal
            ,facturas: this.agregar_email.contacto.facturas
          })).data;

          successMsg = 'El método de contacto se agrego correctamente';
        }

        this.usuario.contactos = resContactos;
        this.cancelar_contacto_modal();
        this.mostrar_otp_modal = false;
        this.$swal('Exito!',successMsg,'success');
      }catch(e) {
        this.$helper.axios_error(e);

        // if (e.response && e.response.data && e.response.error == 400)
        //   this.$swal('Error','Error al enviar el método de contacto: '+e.response.data.error.codigo[0],'error');
        // else
        //   this.$swal('Error','Error al enviar el método de contacto: '+e.message,'error');
      }
    }
    ,editar_email_modal: function(contacto) {
      this.agregar_metodo_contacto('editar_email')
      this.editar_email = {
        mostrar: true
        ,contacto: contacto
        ,otp: {
          destinatario: JSON.parse(JSON.stringify(contacto)).valor
          ,codigo: null
        }
      }
    }
    ,subir_avatar: async function(e) {
      if (e.target.files.length == 0)
        this.$swal('Error','Debes seleccionar un archivo a subir','error');

      try {
        let form = new FormData();
        form.append('avatar',e.target.files[0]);

        await api.subir_avatar(form);

        this.$swal('Exito!','La imagen fue subida correctamente','success');
        this.editar_avatar = false;
        this.cargar_avatar();
      }catch(e) {
        this.$log.info('err',e);
        this.$swal('Error','Error al subir la imagen: '+e.message,'error');
      }
    }
    ,eliminar_email_modal: async function(contacto) {
      try {
        let res = (await apiClientes.eliminar_metodo_contacto(contacto.id)).data;

        this.usuario.contactos = res;
      }catch(e) {
        this.$log.info('err',e);
        this.$swal('Error','Error al eliminar el contacto: '+e.message,'error');
      }
    }
    ,crear_domicilio: async function() {
      try {
        let res = (await apiClientes.crear_direccion(this.crear_direccion)).data;

        this.usuario.direcciones = res;
        this.agregar_domicilio = false;
        this.crear_direccion = {
          calle: null
          ,no_interior: null
          ,no_exterior: null
          ,colonia: null
          ,delegacion: null
          ,estado: null
          ,cp: null
          ,principal: null
        }
      }catch(e) {
        this.$log.info('err',e);
        this.$swal('Error','Error al eliminar el contacto: '+e.message,'error');
      }
    }
    ,editar_domicilio_modal: function(direccion) {
      this.crear_direccion = direccion;
      this.editar_domicilio = true;
    }
    ,actualizar_domicilio: async function() {
      try {
        let res = (await apiClientes.editar_direccion(this.crear_direccion.id, this.crear_direccion)).data;

        this.usuario.direcciones = res;
        this.editar_domicilio = false;
        this.crear_direccion = {
          calle: null
          ,no_interior: null
          ,no_exterior: null
          ,colonia: null
          ,delegacion: null
          ,estado: null
          ,cp: null
          ,principal: null
        }
      }catch(e) {
        this.$log.info('err',e);
        this.$swal('Error','Error al eliminar el contacto: '+e.message,'error');
      }
    }
    ,cancelar_direccion: function() {
        this.agregar_domicilio = false;
        this.editar_domicilio = false;
        this.crear_direccion = {
          calle: null
          ,no_interior: null
          ,no_exterior: null
          ,colonia: null
          ,delegacion: null
          ,estado: null
          ,cp: null
          ,principal: null
        }
    }
    ,eliminar_domicilio_modal: async function(direccion) {
      try {
        if (direccion.principal)
          return this.$swal('Error','No puedes eliminar una dirección predeterminada','error');

        this.usuario.direcciones = (await apiClientes.eliminar_direccion(direccion.id)).data
      }catch(e) {
        this.$log.info('err',e);
        this.$swal('Error','Error al eliminar el contacto: '+e.message,'error');
      }
    }
    ,agregar_metodo_contacto: function(metodo) {
      this.$log.info('metodo', metodo);

      if (metodo == 'editar_telefono') {
        this.editar_telefono.mostrar = true;
        this.editar_telefono.otp.destinatario = null;
        this.agregar_telefono.mostrar = false;
        this.agregar_telefono.otp.destinatario = null;
        this.editar_email.mostrar = false;
        this.editar_email.otp.destinatario = null;
        this.agregar_email.mostrar = false;
        this.agregar_email.otp.destinatario = null;
        this.editar_domicilio = false;
        this.agregar_domicilio = false;
      }

      if (metodo == 'agregar_telefono') {
        this.editar_telefono.mostrar = false;
        this.editar_telefono.otp.destinatario = null;
        this.agregar_telefono.mostrar = true;
        this.agregar_telefono.otp.destinatario = null;
        this.editar_email.mostrar = false;
        this.editar_email.otp.destinatario = null;
        this.agregar_email.mostrar = false;
        this.agregar_email.otp.destinatario = null;
        this.editar_domicilio = false;
        this.agregar_domicilio = false;
      }

      if (metodo == 'editar_email') {
        this.editar_telefono.mostrar = false;
        this.editar_telefono.otp.destinatario = null;
        this.agregar_telefono.mostrar = false;
        this.agregar_telefono.otp.destinatario = null;
        this.editar_email.mostrar = true;
        this.editar_email.otp.destinatario = null;
        this.agregar_email.mostrar = false;
        this.agregar_email.otp.destinatario = null;
        this.editar_domicilio = false;
        this.agregar_domicilio = false;
      }

      if (metodo == 'agregar_email') {
        this.editar_telefono.mostrar = false;
        this.editar_telefono.otp.destinatario = null;
        this.agregar_telefono.mostrar = false;
        this.agregar_telefono.otp.destinatario = null;
        this.editar_email.mostrar = false;
        this.editar_email.otp.destinatario = null;
        this.agregar_email.mostrar = true;
        this.agregar_email.otp.destinatario = null;
        this.editar_domicilio = false;
        this.agregar_domicilio = false;
      }

      if (metodo == 'editar_direccion') {
        this.editar_telefono.mostrar = false;
        this.editar_telefono.otp.destinatario = null;
        this.agregar_telefono.mostrar = false;
        this.agregar_telefono.otp.destinatario = null;
        this.editar_email.mostrar = false;
        this.editar_email.otp.destinatario = null;
        this.agregar_email.mostrar = true;
        this.agregar_email.otp.destinatario = null;
        this.editar_domicilio = true;
        this.agregar_domicilio = false;
      }

      if (metodo == 'agregar_direccion') {
        this.editar_telefono.mostrar = false;
        this.editar_telefono.otp.destinatario = null;
        this.agregar_telefono.mostrar = false;
        this.agregar_telefono.otp.destinatario = null;
        this.editar_email.mostrar = false;
        this.editar_email.otp.destinatario = null;
        this.agregar_email.mostrar = true;
        this.agregar_email.otp.destinatario = null;
        this.editar_domicilio = false;
        this.agregar_domicilio = true;
      }
    }
    ,eliminar_telefono: async function(contacto) {
      try {
        let res = (await apiClientes.eliminar_metodo_contacto(contacto.id)).data;

        this.usuario.contactos = res;
      }catch(e) {
        this.$log.info('err',e);
        this.$swal('Error','Error al eliminar el contacto: '+e.message,'error');
      }
    }
  }
  ,computed: {
    metodo_contacto_email: function(e) {
      let emails = [];

      this.usuario.contactos.forEach(contacto => {
        if (contacto.tipo == 'email')
          emails.push(contacto);
      })

      return emails;
    }
    ,metodo_contacto_telefono: function() {
      let telefonos = [];

      this.usuario.contactos.forEach(contacto => {
        if (contacto.tipo != 'email')
          telefonos.push(contacto);
      })

      return telefonos;
    }
    ,metodo_factura_preferido: function() {
      let valor = 'No tienes designado un correo para facturas';

      this.usuario.contactos.forEach(contacto => {
        if (contacto.tipo == 'email' && contacto.facturas == 1)
          valor = contacto.valor;
      })

      return valor;
    }
  }
 }
 </script>
<style lang="scss">
.modal-active {
  display: block;
}
</style>
